import type { I18nOptions } from '@yandex-int/i18n';
import i18nFactory, { i18nRaw } from '@yandex-int/i18n';

export function typedI18nFactory<Ten, Tru>(keyset: { ru: Tru; en: Ten }) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return i18nFactory(keyset as any) as (
        key: keyof Tru & keyof Ten,
        options?: I18nOptions,
    ) => string;
}

type RawResult = string | number | object | undefined;

export function typedI18nRawFactory<Ten, Tru>(keyset: { ru: Tru; en: Ten }) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return i18nRaw(keyset as any) as (
        key: keyof Tru & keyof Ten,
        options?: I18nOptions,
    ) => RawResult[];
}
